import { addHeaders, post, get } from '../utils/api/api'
import { findGetParameter } from '../utils/scene/utils/findGetParameter'
import storage from '../utils/storage/storage'

export const _storage = storage('info', ({ access_token } = {}) => {
  if (!access_token) return
  addHeaders({
    Authorization: access_token ? `Bearer ${access_token}` : undefined,
  })
})

const savedInfo = _storage.load()
if (savedInfo?.ecomToken) {
  _storage.save({}, { removeKeys: ['ecomToken'] })
}

export const requestCache = {}

let mockGameData = {
  games: [{ levels: [{ is_complete: false }, { is_complete: false }, { is_complete: false }] }],
}

export async function mockGame() {
  return { ...mockGameData }
}

export function getUserProfile() {
  return post(
    '/user/profile',
    {},
    { apmCustomErrorMessage: 'Не удалось получить данные пользователя' },
  )
}

export function update(data) {
  return post('/user/update', data, {
    apmCustomErrorMessage: 'Не удалось обновить данные пользователя',
  })
}

export function generateName() {
  return post(
    '/user/generate-username',
    {},
    { apmCustomErrorMessage: 'Не удалось сгенерировать никнейм' },
  ).then(saveAuth)
}

export function beautyProcedure(id) {
  return post(
    `/game/beauty-procedure?id=${id}`,
    {},
    { apmCustomErrorMessage: 'Не удалось провести бьюти процедуру' },
  ).then(saveAuth)
}

export function gameStart({ id }) {
  return post(`/game/start?levelId=${id}`, {}, { apmCustomErrorMessage: 'Не удалось начать игру' })
}

export function gameEnd({ collectedPromo }) {
  return post(
    `/game/end`,
    { collectedPromo },
    { apmCustomErrorMessage: 'Не удалось закончить игру' },
  ).then(saveAuth)
}

export function gamePause() {
  return post(
    `/game/pause`,
    {},
    { apmCustomErrorMessage: 'Не удалось поставить/снять игру с паузы' },
  )
}

export function getBeautiesBalance() {
  return get(
    '/user/beauties-balance',
    {},
    { apmCustomErrorMessage: 'Не удалось получить баланс бьютисов пользователя' },
  )
}

export function saveAuth(data) {
  if (data.message === 'waitSms') return data
  if (!data?.profile) return data
  if (findGetParameter('forceAuth')) data.profile.processingStatus = false
  _storage.save(data.profile)
  return data
}

export function saveToken(data) {
  if (!data?.access_token) return

  const { access_token } = data
  _storage.save({ access_token }, { removeKeys: ['ecomToken'] })
  return data
}

export function saveError(data) {
  return post(`/site/new-error`, data)
}

export function setCountry(userCountry) {
  return post('/user/set-country', { userCountry }).then(saveAuth)
}

export function getAttempts() {
  return get(
    '/user/attempts',
    {},
    { apmCustomErrorMessage: 'Не удалось получить данные по энергии' },
  )
}

export function getUserPrizes() {
  return get(
    '/user/prizes',
    {},
    { apmCustomErrorMessage: 'Не удалось получить призы пользователя' },
  )
}
